import { Check } from "lucide-react";

export default function DataTableBooleanCell({ value }: { value: boolean }) {
  return <>{value && <Check size="18" />}</>;
}
